import React, { ReactElement } from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';

function CcxIconPlusCircleOutlined(): ReactElement {
    return <PlusCircleOutlined data-testid="CcxIconPlusCircleOutlined" />;
}

export default CcxIconPlusCircleOutlined;
